import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/pro-light-svg-icons';

export const AngleDownIcon = () => (
    <div className="angle-updown-icon">
        <FontAwesomeIcon icon={faAngleDown} />
    </div>
)
export default AngleDownIcon;




// WEBPACK FOOTER //
// ./src/components/icons/AngleDownIcon.js